import NotesButtonAndDropdown from './NotesButtonAndDropdown';
import connect from './NotesButtonAndDropdown.container';
export default connect(NotesButtonAndDropdown);
